import { render, staticRenderFns } from "./uploadImgJavan.vue?vue&type=template&id=7a643672&"
import script from "./uploadImgJavan.vue?vue&type=script&lang=js&"
export * from "./uploadImgJavan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports